import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import SidebarIcon from "../../icons/svg/SidebarIcon.svg?react";
import {DrawerTopBar} from "./DrawerTopBar.tsx";
import {DrawerMenu} from "./DrawerMenu.tsx";
import {DrawerHeader} from "./DrawerHeader.tsx";
import {useStores} from "../../../stores";
import {observer} from "mobx-react-lite";
import type {AppBarProps} from "@mui/material/AppBar";
import {MainFooter} from "../MainFooter.tsx";

const color: AppBarProps["color"] = "default";

type Props = {
    className?: string;
    menu?: React.ReactNode;
    topHeader?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
};
export const DrawerMain: React.FC<Props> = observer(
    ({className, menu, topHeader, children}) => {
        const {rootAppStore} = useStores();
        const open = rootAppStore.isDrawerOpen;

        const handleDrawerToggle = React.useCallback(() => {
            rootAppStore.setIsDrawerOpen(!rootAppStore.isDrawerOpen);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <div id="main-component-root" className={className}>
                <DrawerTopBar
                    id="main-component-top-bar"
                    position="fixed"
                    open={open}
                    color={color}
                    elevation={0}
                >
                    <Toolbar>{topHeader}</Toolbar>
                </DrawerTopBar>
                <DrawerMenu
                    id="main-component-menu-drawer"
                    sx={{
                        "& .MuiDrawer-paper": {
                            px: open ? "8px" : "14px",
                            py: "12px",
                            transition: "all 0.3s",
                        },
                    }}
                    variant="permanent"
                    open={open}
                    color={color}
                    slotProps={{paper: {elevation: 0}}}
                >
                    <IconButton
                        sx={{
                            alignSelf: "flex-start",
                            marginBottom: "36px",
                            marginLeft: open ? "4px" : "0px",
                        }}
                        onClick={handleDrawerToggle}
                    >
                        <SidebarIcon/>
                    </IconButton>
                    {menu}
                    {open && <MainFooter/>}
                </DrawerMenu>
                <div id="main-component-wrapper">
                    <DrawerHeader/>
                    {/* Filler */}
                    {children}
                </div>
            </div>
        );
    },
);
